/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelUserMenuFavorite.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "common/user-menu-favorite";

export class AutogenModelUserMenuFavorite<RowType extends ModelRow> extends Endpoint<RowType, RowUserMenuFavoriteFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowUserMenuFavorite extends ModelRow<RowUserMenuFavoriteFields> {
    constructor(values?: Partial<RowUserMenuFavoriteFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowUserMenuFavoriteFields {
    caption: string;
    company_id: string;
    id: string;
    image: string;
    params: string;
    path: string;
    sequence: number;
    user_id: string;
}

